import React, { Component } from 'react'
// import Logo from './Logo.js'
// import GetChromeExtension from './GetChromeExtension.js'

class PageNotFound extends Component {
  render() {
    return (
      <div className="page-notfound">
        <p>Error 404</p>
        <p>Video not found</p>
      </div>
    )
  }
}

export default PageNotFound



/** WEBPACK FOOTER **
 ** ./src/scripts/components/PageNotFound.js
 **/